module.exports = __webpack_public_path__ + "img/carousel02.5dc22103.png";